'use client';

import { useSiteSettings } from '@/components/providers';
import { ContactDetails } from './ContactDetails';

type ContactDetailsFromSettingsProps = {
    className?: string;
};

/**
 * The same block, for callers that are not the footer and so do not already
 * hold the settings. It reads them from the provider the layout puts up rather
 * than fetching again — which is what every other settings-driven piece on the
 * page does.
 */
export function ContactDetailsFromSettings({ className }: ContactDetailsFromSettingsProps) {
    const settings = useSiteSettings();

    return (
        <ContactDetails
            contact={settings.contactData}
            socialLinks={settings.socialLinks}
            socialLabel={settings.footer?.socialLabel}
            className={className}
        />
    );
}
